import { Shield, Headphones, MousePointer, Award } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const BenefitsSection = () => {
  const { t } = useLanguage();

  const benefits = [
    {
      icon: Shield,
      title: t.benefits.safe.title,
      description: t.benefits.safe.description,
    },
    {
      icon: Headphones,
      title: t.benefits.customerService.title,
      description: t.benefits.customerService.description,
    },
    {
      icon: MousePointer,
      title: t.benefits.easyBooking.title,
      description: t.benefits.easyBooking.description,
    },
    {
      icon: Award,
      title: t.benefits.satisfaction.title,
      description: t.benefits.satisfaction.description,
    },
  ];

  return (
    <section id="om-oss" className="section-spacing bg-neutral-950/50" data-testid="benefits-section">
      <div className="section-container">
        {/* Header */}
        <div className="text-left mb-16">
          <span className="text-yellow-500 text-sm font-semibold tracking-widest uppercase mb-4 block">
            {t.benefits.title}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t.benefits.subtitle}
          </h2>
          <p className="text-neutral-400 text-lg max-w-2xl">
            {t.benefits.description}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="feature-card flex gap-6"
              data-testid={`benefit-card-${index}`}
            >
              <div className="service-icon flex-shrink-0">
                <benefit.icon className="w-7 h-7" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {benefit.title}
                </h3>
                <p className="text-neutral-400 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
